// import './index.css';
import * as d3 from 'd3';
window.d3 = d3;
import { default as LineChart } from './LineChart';
import { default as ForceGraph } from './ForceGraph';
import { BarChart } from './BarChart';
import { default as HexBin } from './HexBin';
import { Dendro } from './Dendro';
import { Bubble } from './Bubble';
import { default as Pie } from './Pie';
import { default as Lolli } from './Lolli';
import { default as Scatter } from './Scatter';
import { default as BoxPlot } from './BoxPlot';

export const AVLineChart = LineChart;
export const AVForceGraph = ForceGraph;
export const AVBarChart = BarChart;
export const AVHexBin = HexBin;
export const AVDendro = Dendro;
export const AVBubble = Bubble;
export const AVPie = Pie;
export const AVLolli = Lolli;
export const AVScatter = Scatter;
export const AVBoxPlot = BoxPlot;

export default {
  LineChart,
  ForceGraph,
  BarChart,
  HexBin,
  Dendro,
  Bubble,
  Pie,
  Lolli,
  Scatter,
  BoxPlot,
};
